<template>
  <div class="client-service-subtype__item">{{subcat_name}}</div>
</template>

<script>
export default {
    name: "OneSubtype",
    props: {
        subcat_name: String,
        subcat_id: Number,
        subcat_amout: Number,
        subcat_index: Number
    },
}
</script>
